import React, { useState, useEffect, useRef } from "react";
import logger from './utils/logger.js';


const VideoComponent = () => {
  const [activeTab, setActiveTab] = useState("video");
  const [cameraDevices, setCameraDevices] = useState([]);
  const [selectedCamera, setSelectedCamera] = useState("");
  const [videoQuality, setVideoQuality] = useState("");
  const videoRef = useRef(null);

  // Fetch available camera devices
  useEffect(() => {
    const fetchCameraDevices = async () => {
      try {
        const devices = await navigator.mediaDevices.enumerateDevices();
        const videoDevices = devices.filter((device) => device.kind === "videoinput");
        setCameraDevices(videoDevices);
        if (videoDevices.length > 0) {
          setSelectedCamera(videoDevices[0].deviceId);
        }
      } catch (error) {
        logger.error("Error fetching camera devices:", error);
      }
    };

    fetchCameraDevices();
  }, []);

  // Update video stream when selectedCamera changes
  useEffect(() => {
    const updateVideoStream = async (deviceId) => {
      if (!videoRef.current) return;

      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: { deviceId: deviceId ? { exact: deviceId } : undefined },
        });
        videoRef.current.srcObject = stream;
      } catch (error) {
        logger.error("Error accessing camera:", error);
      }
    };

    if (activeTab === "video" && selectedCamera) {
      updateVideoStream(selectedCamera);
    }
  }, [activeTab, selectedCamera]);

  const renderContent = () => {
    switch (activeTab) {
      case "video":
        return (
            <div>

            <div style={{ marginTop: '8px' }} />
            <div className="w-full rounded-md" style={{ aspectRatio: '16/9', backgroundColor: 'black', overflow: 'hidden' }}>
              <video
                ref={videoRef}
                autoPlay
                muted
                style={{ 
                  width: "100%", 
                  height: "100%", 
                  objectFit: "cover",
                  borderRadius: '8px'
                }}
              />
            </div>

            
            <p className="w-[500px] text-left mt--4 text-[18px] font-normal leading-[28px] tracking-[-0.4px] text-[#93949d]">
              Make sure you are in a well-lit environment and your face is centered in the frame.
            </p>

            {videoQuality && (
              <div className="mt-2 text-gray-500">
                Video Quality: {videoQuality}
              </div>
            )}
          </div>
        );
      default:
        return <div>Unknown Tab</div>;
    }
  };

  return (
    <div className="content">{renderContent()}</div>
  );
};

export default VideoComponent;